"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/card/style");
var _card = _interopRequireDefault(require("antd/lib/card"));
require("antd/lib/input-number/style");
var _inputNumber = _interopRequireDefault(require("antd/lib/input-number"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _async = _interopRequireDefault(require("react-select/async"));
var _utils = require("../../../utils");
var _ImageUploader = _interopRequireWildcard(require("../../ImageUploader"));
var _types = require("../../../types");
var _Toggle = require("../../../components/Toggle");
var _util = require("../util");
var _DropdownIndicator = require("../../SearchableReactSelect/components/DropdownIndicator");
var _api = require("../api");
var _constants = require("../constants");
var _AuthProvider = require("../../AuthProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Option = _select.default.Option;
var Text = _typography.default.Text;
var useSelectSearch = function useSelectSearch(data) {
  var _useState = (0, _react.useState)(data),
    _useState2 = _slicedToArray(_useState, 2),
    filteredData = _useState2[0],
    setFilteredData = _useState2[1];
  (0, _react.useEffect)(function () {
    setFilteredData(data);
  }, [data]);
  var onSearch = (0, _react.useCallback)(function (value) {
    var filtered = value ? data.filter(function (e) {
      var _e$name;
      return e === null || e === void 0 ? void 0 : (_e$name = e.name) === null || _e$name === void 0 ? void 0 : _e$name.toLowerCase().includes(value.toLowerCase());
    }) : data;
    setFilteredData(filtered);
  }, [data]);
  // put therapist names in alphabetical order
  if (filteredData) {
    filteredData.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }
  return {
    filteredData: filteredData,
    onSearch: onSearch
  };
};
var imageValidators = [(0, _ImageUploader.maxImageSizeValidator)(20, 'Please use image with size less than 20 Mb'), (0, _ImageUploader.isAllowedTypeValidator)(_utils.ACCEPT_IMAGE_TYPES, function (file, fileType) {
  return (0, _ImageUploader.composeAcceptedFileTypesText)(_utils.ACCEPT_IMAGE_TYPES, fileType);
})];
var GroupInfo = function GroupInfo(props) {
  var _group$clinician;
  var clinicians = props.clinicians,
    _props$form = props.form,
    getFieldDecorator = _props$form.getFieldDecorator,
    getFieldsError = _props$form.getFieldsError,
    validateFieldsAndScroll = _props$form.validateFieldsAndScroll,
    getFieldValue = _props$form.getFieldValue,
    group = props.group,
    isEditable = props.isEditable,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    loadingClinicians = props.loadingClinicians,
    onStatusUpdate = props.onStatusUpdate,
    onSubmit = props.onSubmit;
  var _useAuth = (0, _AuthProvider.useAuth)(),
    user = _useAuth.user;
  var isAdminUser = (0, _utils.isAdmin)(user);
  var _useSelectSearch = useSelectSearch(clinicians),
    filteredData = _useSelectSearch.filteredData,
    onSearch = _useSelectSearch.onSearch;
  var isArchived = group.archived,
    clinicianModerators = group.clinicianModerators,
    patientModerators = group.patientModerators,
    groupSessions = group.groupSessions;
  var history = (0, _reactRouterDom.useHistory)();
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    image = _useState4[0],
    setImage = _useState4[1];
  var ownerId = getFieldValue('clinicianId');
  var _useClinicianAndPatie = (0, _api.useClinicianAndPatientModeratorsSearch)(props.form, ownerId),
    onLoadClinicianOptions = _useClinicianAndPatie.onLoadClinicianOptions,
    onLoadPatientOptions = _useClinicianAndPatie.onLoadPatientOptions;
  var _getReactSelectClinic = (0, _util.getReactSelectClinicianAndPatientModerators)({
      clinicianModerators: clinicianModerators,
      patientModerators: patientModerators
    }),
    clinicianModeratorOptions = _getReactSelectClinic.clinicianModeratorOptions,
    patientModeratorOptions = _getReactSelectClinic.patientModeratorOptions;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    validateFieldsAndScroll(function (err, formValues) {
      var isApplyImageValidation = !group.image || image;
      var isImageValid = !isApplyImageValidation || (0, _ImageUploader.validateImage)(image);
      if (!isImageValid || err) {
        return;
      }
      var data = (0, _lodash.pickBy)(formValues, function (val) {
        var trimmedVal = (0, _lodash.trim)(val);
        return (0, _lodash.isNumber)(trimmedVal) || !(0, _lodash.isEmpty)(trimmedVal);
      });
      var clinicianModerators = formValues.clinicianModerators,
        patientModerators = formValues.patientModerators;
      var clinicianModeratorIds = clinicianModerators === null || clinicianModerators === void 0 ? void 0 : clinicianModerators.map(function (m) {
        return m.value;
      });
      var patientModeratorIds = patientModerators === null || patientModerators === void 0 ? void 0 : patientModerators.map(function (m) {
        return m.value;
      });
      onSubmit(_objectSpread(_objectSpread({}, (0, _lodash.omit)(data, [_constants.CLINICIAN_MODERATORS_FIELD_NAME, _constants.PATIENT_MODERATORS_FIELD_NAME])), {}, {
        upload: data.upload[0],
        clinicianModeratorIds: clinicianModeratorIds,
        patientModeratorIds: patientModeratorIds
      }));
    });
  };
  var fieldsError = getFieldsError();
  var validationErrors = (0, _react.useMemo)(function () {
    return (0, _lodash.chain)(fieldsError).values().compact().some(function (e) {
      return e;
    }).value();
  }, [fieldsError]);
  var handleSelectStatus = (0, _react.useCallback)(function (value) {
    onStatusUpdate(value);
  }, [onStatusUpdate, group]);

  // @TODO: can this be moved into `useChat` as something like `onOpenGroupChat`?
  var openChat = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(group) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _utils.updateChatToMoveOnTop)({
                channelId: group.id
              });
            case 2:
              history.push("/chat/".concat(_utils.MESSENGER_TABS.GROUP, "/").concat(group.id, "?").concat(_utils.SORT_CHANNEL_BY_QUERY_NAME, "=updated_at"));
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function openChat(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var type = getFieldValue('type');
  var isWebinarChecked = !!getFieldValue('isWebinar');
  var isCurrentlyPrivate = type === _utils.GroupTypes.Private;
  var filterModeratorOptions = function filterModeratorOptions(option) {
    return option ? option.data.value !== ownerId : false;
  };
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading,
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-inner",
    bordered: false
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    gutter: 16,
    type: "flex"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 18,
    md: 16,
    lg: 16,
    xl: 20
  }, isCurrentlyPrivate && /*#__PURE__*/_react.default.createElement("div", {
    className: "text-alertred-60 tw-body-medium mb-[24px]"
  }, "This group is currently set as private, please copy the link(s) below to share it. group access:"), /*#__PURE__*/_react.default.createElement("div", null, "Patient group details page (always available):"), /*#__PURE__*/_react.default.createElement("div", {
    className: "my-[24px]"
  }, /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, "".concat(process.env.REACT_APP_APPLICATION_URL, "/patient").concat(_utils.GroupUtil.getDetailURL(group.slug, group.id)))), /*#__PURE__*/_react.default.createElement("div", null, "Patient group video page (available 5 minutes before start):"), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[24px]"
  }, /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, (0, _util.patientVideoLink)(group.id)))), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 6,
    md: 8,
    lg: 8,
    xl: 4
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    justify: "end",
    type: "flex"
  }, /*#__PURE__*/_react.default.createElement(_select.default, {
    value: group.status,
    onSelect: handleSelectStatus,
    disabled: !onStatusUpdate || !isEditable,
    loading: group.processing
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: _types.GroupStatus.Active
  }, _utils.GroupStatusText[_types.GroupStatus.Active]), /*#__PURE__*/_react.default.createElement(Option, {
    value: _types.GroupStatus.ComingSoon
  }, _utils.GroupStatusText[_types.GroupStatus.ComingSoon]), /*#__PURE__*/_react.default.createElement(Option, {
    value: _types.GroupStatus.Archived
  }, _utils.GroupStatusText[_types.GroupStatus.Archived]))))), /*#__PURE__*/_react.default.createElement(_row.default, {
    gutter: 16,
    type: "flex"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "go-to-chat-button"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "secondary",
    onClick: function onClick() {
      openChat(group);
    },
    size: "small",
    block: true
  }, "Go to \u0421hat"))), /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit,
    className: "AddGroupForm",
    size: "large",
    hideRequiredMark: true
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Name"
  }, isEditable ? getFieldDecorator('name', {
    initialValue: group.name,
    rules: [{
      required: true,
      message: 'Please enter group name',
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    disabled: isArchived,
    placeholder: "Enter group name",
    size: "large"
  })) : /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, group.name)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Days and Times"
  }, /*#__PURE__*/_react.default.createElement(Text, {
    style: {
      fontSize: '18px'
    }
  }, _utils.GroupUtil.renderRecurringTimesText(groupSessions))), (clinicians === null || clinicians === void 0 ? void 0 : clinicians.length) && /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Owner"
  }, getFieldDecorator('clinicianId', {
    initialValue: (_group$clinician = group.clinician) === null || _group$clinician === void 0 ? void 0 : _group$clinician.id,
    rules: [{
      required: true,
      message: 'Please select a moderator'
    }]
  })( /*#__PURE__*/_react.default.createElement(_select.default, {
    disabled: isArchived || !isEditable,
    onSearch: onSearch,
    showSearch: true,
    size: "large",
    filterOption: false,
    suffixIcon: loadingClinicians && /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: "loading"
    }),
    placeholder: "Select moderator"
  }, filteredData.map(function (clinician) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      value: clinician.value,
      key: clinician.value
    }, clinician.name);
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Group type"
  }, getFieldDecorator('type', {
    initialValue: group.type,
    rules: [{
      required: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_select.default, {
    showSearch: false,
    size: "large",
    filterOption: false,
    placeholder: "Select group type",
    disabled: !isAdminUser
  }, Object.values(_utils.GroupTypes).map(function (type) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      value: type,
      key: type
    }, type);
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Group is a webinar"
  }, getFieldDecorator('isWebinar', {
    initialValue: group.isWebinar,
    rules: [{
      required: false
    }]
  })( /*#__PURE__*/_react.default.createElement(_Toggle.Toggle, {
    disabled: !isAdminUser
  }))), isWebinarChecked && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Select more clinician moderators"
  }, getFieldDecorator(_constants.CLINICIAN_MODERATORS_FIELD_NAME, {
    initialValue: clinicianModeratorOptions,
    rules: [{
      required: false
    }]
  })( /*#__PURE__*/_react.default.createElement(_async.default, {
    className: "searchable-react-select mb-[24px] mt-0",
    classNamePrefix: "searchable-select-inner",
    placeholder: "Search clinician moderators...",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: _DropdownIndicator.DropdownIndicator
    },
    filterOption: filterModeratorOptions,
    loadOptions: onLoadClinicianOptions,
    isClearable: false,
    isDisabled: !isAdminUser,
    isMulti: true
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Select more patient moderators"
  }, getFieldDecorator(_constants.PATIENT_MODERATORS_FIELD_NAME, {
    initialValue: patientModeratorOptions,
    rules: [{
      required: false
    }]
  })( /*#__PURE__*/_react.default.createElement(_async.default, {
    className: "searchable-react-select mb-[24px] mt-0",
    classNamePrefix: "searchable-select-inner",
    placeholder: "Search patient moderators...",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: _DropdownIndicator.DropdownIndicator
    },
    filterOption: filterModeratorOptions,
    loadOptions: onLoadPatientOptions,
    isClearable: false,
    isDisabled: !isAdminUser,
    isMulti: true
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Description"
  }, isEditable ? getFieldDecorator('description', {
    initialValue: group.description,
    rules: [{
      required: true,
      message: 'Please enter description',
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default.TextArea, {
    disabled: isArchived || !isEditable,
    placeholder: "Enter description",
    size: "large"
  })) : /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, group.description)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Welcome message"
  }, isEditable ? getFieldDecorator('welcomeMessage', {
    initialValue: group.welcomeMessage,
    rules: [{
      required: true,
      message: 'Please enter welcome message',
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default.TextArea, {
    disabled: isArchived || !isEditable,
    placeholder: "Enter therapist\u2019s welcome message",
    size: "large"
  })) : /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, group.welcomeMessage)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "How it works"
  }, isEditable ? getFieldDecorator('howItWorks', {
    initialValue: group.howItWorks,
    rules: [{
      required: false,
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default.TextArea, {
    disabled: isArchived || !isEditable,
    placeholder: "Enter how it works text",
    size: "large"
  })) : /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, group.howItWorks)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Resources"
  }, isEditable ? getFieldDecorator('resources', {
    initialValue: group.resources,
    rules: [{
      required: false,
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default.TextArea, {
    disabled: isArchived || !isEditable,
    placeholder: "Enter resources text",
    size: "large"
  })) : /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, group.resources)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Group introduction video URL"
  }, isEditable ? getFieldDecorator('videoUrl', {
    initialValue: group.videoUrl,
    rules: [{
      required: false,
      whitespace: true
    }, {
      validator: (0, _utils.urlValidator)()
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    disabled: isArchived || !isEditable,
    placeholder: "Group introduction video URL",
    size: "large"
  })) : /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, group.videoUrl)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "mx-auto ant-upload-row"
  }, isEditable ? getFieldDecorator('upload', {
    valuePropName: 'fileList',
    rules: [{
      required: true,
      message: 'Please select a therapist'
    }]
  })( /*#__PURE__*/_react.default.createElement(_ImageUploader.default, {
    disabled: isArchived || !isEditable,
    imageId: group.image,
    validators: imageValidators,
    viewMode: _ImageUploader.UploaderViewModes.LABELLED_CARD,
    onDecodeImage: setImage,
    previewImageSrc: (0, _utils.getCdnBucketImageUrl)(group.image)
  })) : /*#__PURE__*/_react.default.createElement("img", {
    className: "h-[256px] w-auto",
    src: (0, _utils.composeGroupImageUrl)(group),
    alt: "Thumbnail for ".concat(group.name)
  })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "RSVP Capacity"
  }, getFieldDecorator('capacity', {
    first: true,
    initialValue: group.capacity,
    rules: [{
      required: true,
      message: 'Please enter the session’s rsvp capacity'
    }]
  })( /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
    disabled: isArchived || !isEditable,
    min: 1,
    max: _utils.MAX_DAILYCO_GROUP_SESSION_CAPACITY
  }))), isEditable && /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    htmlType: "submit",
    size: "large",
    block: true,
    disabled: isArchived || validationErrors
  }, "Update group")))));
};
GroupInfo.propTypes = {
  clinicians: _propTypes.default.array,
  group: _propTypes.default.object.isRequired,
  isEditable: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  loadingClinicians: _propTypes.default.bool,
  onStatusUpdate: _propTypes.default.func,
  onSubmit: _propTypes.default.func.isRequired
};
var _default = _form.default.create({
  name: 'GroupInfo'
})(GroupInfo);
exports.default = _default;